// extracted by mini-css-extract-plugin
export default {"root":"Logo__root--158cg","themeOutsourceLogo":"Logo__themeOutsourceLogo--22UKc","disableEvents":"Logo__disableEvents--3mRtO"};